/**
 * RichText - Core Component (Standalone)
 *
 * Renders rich text/HTML content from the CMS using parseRichText.
 * Transforms <p>, <a> etc. to React components (Copytext, Button).
 */
import React from 'react';
import {
  parseRichText as parseRichTextFn,
  type RichTextClassConfig,
} from '@/app/_lib/parse-rich-text';
import { cn } from '@/app/_lib/utils';

export interface RichTextProps {
  children: string;
  className?: string;
  /** Override CSS classes on rendered elements */
  classConfig?: RichTextClassConfig;
}

export function RichText({
  children,
  className,
  classConfig,
}: RichTextProps) {
  const content = parseRichTextFn(children, { classConfig });

  return (
    <div className={cn('max-w-2xl [&>*:last-child]:mb-0', className)}>
      {content}
    </div>
  );
}

export type { RichTextClassConfig };
